import lumiaLogo from '@/assets/clients/lumia.png';
import delabsLogo from '@/assets/clients/delabs.png';
import dextoolsLogo from '@/assets/clients/dextools.png';
import pancakeLogo from '@/assets/clients/pancakeswap.png';
import tonmarketLogo from '@/assets/clients/tonmarket.png';
import hyperlaunchLogo from '@/assets/clients/hyperlaunch.png';
import locusLogo from '@/assets/clients/locus.png';
import preduckLogo from '@/assets/clients/preduck.png';
import aquaLogo from '@/assets/clients/aqua.png';
import jbotLogo from '@/assets/clients/jbot.png';
import odinLogo from '@/assets/clients/odin.png';
import savantChatLogo from '@/assets/clients/savant-chat.png';

const clients = [
  { name: 'Lumia', logo: lumiaLogo, link: 'https://github.com/BugBlow/audits/blob/main/IDO_Security_Audit_Report_By_BugBlow.pdf' },
  { name: 'Delabs Games', logo: delabsLogo, link: 'https://github.com/BugBlow/audits/blob/main/Delabs_BSX_Security_Audit_Report_By_BugBlow.pdf' },
  { name: 'DEXTools', logo: dextoolsLogo, link: 'https://dextools.io/' },
  { name: 'Savant Chat', logo: savantChatLogo, link: 'https://savant.chat' },
  { name: 'PancakeSwap', logo: pancakeLogo, link: 'https://github.com/BugBlow/audits/blob/main/Pancake_Swap_Predictions_V2_Security_Audit_Report_By_BugBlow.pdf' },
  { name: 'HyperLaunch', logo: hyperlaunchLogo, link: 'https://github.com/BugBlow/audits/blob/main/HyperLaunch_Security_Audit_Report_By_BugBlow.pdf' },
  { name: 'Locus', logo: locusLogo, link: 'https://www.locus.finance/' },
  { name: 'Preduck Games', logo: preduckLogo, link: 'https://github.com/BugBlow/audits/tree/main/PreduckGames' },
  { name: 'J-Bot', logo: jbotLogo, link: 'https://j-bot.xyz/' },
  { name: 'OdinTrade', logo: odinLogo, link: 'https://github.com/BugBlow/audits/blob/main/OdinTrade_Security_Audit_Report_By_BugBlow.pdf' },
  { name: 'Aqua Protocol', logo: aquaLogo, link: 'https://github.com/BugBlow/audits/blob/main/AquaProtocol/Aqua_Security_Audit_BugBlow.pdf' },
  { name: 'TonMarket', logo: tonmarketLogo, link: 'https://github.com/BugBlow/audits/blob/main/TonMarket_Security_Audit_Report_By_BugBlow.pdf' },
];

const ClientsSection = () => {
  return (
    <section className="py-[75px] relative overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8 mb-[55px]">
        <p className="text-center text-muted-foreground text-xl md:text-2xl lg:text-3xl uppercase tracking-[0.3em]">
          Who we work with
        </p>
      </div>

      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10" />

        <div className="flex overflow-hidden">
          <div className="flex animate-marquee items-center min-w-max will-change-transform" style={{ backfaceVisibility: 'hidden' }}>
            {clients.map((client) => (
              <a
                key={client.name}
                href={client.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 mx-12 opacity-80 hover:opacity-100 transition-opacity duration-300 flex items-center justify-center"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="h-14 md:h-16 lg:h-20 w-auto max-w-[220px] object-contain"
                  width="220"
                  height="80"
                />
              </a>
            ))}
          </div>
          <div className="flex animate-marquee items-center min-w-max will-change-transform" aria-hidden="true" style={{ backfaceVisibility: 'hidden' }}>
            {clients.map((client) => (
              <a
                key={client.name}
                href={client.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 mx-12 opacity-80 hover:opacity-100 transition-opacity duration-300 flex items-center justify-center"
                tabIndex={-1}
              >
                <img
                  src={client.logo}
                  alt=""
                  className="h-14 md:h-16 lg:h-20 w-auto max-w-[220px] object-contain"
                  width="220"
                  height="80"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
